/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SystemDropdownCategory = {
    AppointmentPurpose: 'AppointmentPurpose',
    AttendancePurpose: 'AttendancePurpose',
    CaseNoteType: 'CaseNoteType',
    ClientStatus: 'ClientStatus',
    ClaimBalanceEntryType: 'ClaimBalanceEntryType',
    SrvCourseEntryType: 'SrvCourseEntryType',
    IncomeType: 'IncomeType'
} as const;
export type SystemDropdownCategory = typeof SystemDropdownCategory[keyof typeof SystemDropdownCategory];


export function instanceOfSystemDropdownCategory(value: any): boolean {
    for (const key in SystemDropdownCategory) {
        if (Object.prototype.hasOwnProperty.call(SystemDropdownCategory, key)) {
            if (SystemDropdownCategory[key as keyof typeof SystemDropdownCategory] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SystemDropdownCategoryFromJSON(json: any): SystemDropdownCategory {
    return SystemDropdownCategoryFromJSONTyped(json, false);
}

export function SystemDropdownCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): SystemDropdownCategory {
    return json as SystemDropdownCategory;
}

export function SystemDropdownCategoryToJSON(value?: SystemDropdownCategory | null): any {
    return value as any;
}

export function SystemDropdownCategoryToJSONTyped(value: any, ignoreDiscriminator: boolean): SystemDropdownCategory {
    return value as SystemDropdownCategory;
}

